import React from 'react';
import './Pricing.css';

const Pricing = () => {
  const packages = [
    {
      name: 'Startup Package',
      price: '₹14,999',
      popular: false,
      features: [
        'Company Registration',
        'GST Registration',
        'Basic Accounting (3 months)',
        'Bank Account Opening',
        'TAN Application',
        'Free ITR Filing (1 Year)'
      ]
    },
    {
      name: 'Business Package',
      price: '₹29,999',
      popular: true,
      features: [
        'Everything in Startup',
        'Trademark Registration',
        'Basic Accounting (1 Year)',
        'ESI & PF Registration',
        'MSME Registration',
        'Website Development',
        'Free Legal Consultation'
      ]
    },
    {
      name: 'Enterprise Package',
      price: '₹49,999',
      popular: false,
      features: [
        'Everything in Business',
        'ISO Certification',
        'Premium Accounting',
        'Labour Compliance',
        'Import Export Code',
        'Digital Marketing Support',
        'Dedicated Account Manager',
        '24/7 Priority Support'
      ]
    }
  ];

  return (
    <section id="pricing" className="pricing">
      <div className="container">
        <div className="section-header">
          <h2>Pricing Plans</h2>
          <p>Choose the perfect plan for your business</p>
        </div>
        <div className="pricing-grid">
          {packages.map((pkg, index) => (
            <div key={index} className={`pricing-card ${pkg.popular ? 'popular' : ''}`}>
              {pkg.popular && <div className="popular-badge">Most Popular</div>}
              <h3>{pkg.name}</h3>
              <div className="price">{pkg.price}</div>
              <ul className="features-list">
                {pkg.features.map((feature, idx) => (
                  <li key={idx}>
                    <i className="fas fa-check-circle"></i>
                    {feature}
                  </li>
                ))}
              </ul>
              <button className={`btn ${pkg.popular ? 'btn-primary' : 'btn-outline'}`}>
                Choose Plan
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
